import { LocationPrinter } from './LocationPrinter';
export default LocationPrinter;